<!-- <input type="file"  #fileInput class="image-input" (change)="fileChange($event)"  accept=".jpg,.jpeg,.png">
<button type="submit" class="btn btn-danger"  (click)="fileInput.click()">Upload Image</button>
<img [src]="uploadedFile" class="image-box" /> -->
<!-- 
<input type="file"  #fileInput class="image-input" (change)="fileChange($event)"  accept=".jpg,.jpeg,.png">

<button type="submit" class="btn btn-danger" onclick="document.getElementById('getFile').click()">Upload Image</button>
<img [src]="uploadedFile" class="image-box" /> 

<input #file class="image-input" type="file" accept='image/*' multiple id="getFile" style="display:none"
    (change)="preview(file.files)" />
<ng-container *ngIf="showPreviewImage==true">
    <img [src]="img" *ngFor="let img of previewImage" class="image-box">
</ng-container> -->
<input type="file"  #fileInput class="image-input" (change)="fileChange($event)"  accept=".jpg,.jpeg,.png,.pdf">
<button type="submit" class="btn btn-danger"  (click)="fileInput.click()">{{'UPLOAD_FILE.UPLOAD_IMAGE' | translate}}</button>
<img [src]="uploadedFile" class="image-box" /> 
